import makeStyles from "@mui/styles/makeStyles";
import SiteImporter from "../../components/admin/live2/SiteImporter";

const useStyles = makeStyles(() => ({
  root: {
    display: "flex",
    flexDirection: "column",
    flexGrow: 1,
    height: "100%",
  },
  main: {
    display: "flex",
    flexDirection: "column",
    flexGrow: 1,
  },
}));

function Live2() {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <div className={classes.main}>
        <SiteImporter />
      </div>
    </div>
  );
}

export default Live2;
